import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { camouflageKeys, CamouflageOwnerType } from "../types/camouflageTypes";
import { displayNotify } from "../../../../services/Notifications/NotificationServices";

export default function useUserDeleteCamouflage(type: CamouflageOwnerType, slug: string | null | undefined) {

    const qKeys = camouflageKeys[type]
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (mix_id: string) => {
            //const endpoint = type === 'profile' ? `/user-profile/camouflage/${mix_id}/` : `/team/${slug}/camouflages/${mix_id}/`  //устаревший эндпоинт
            const endpoint = type === 'profile' ? `/users/me/camouflages/${mix_id}/` : `/team/${slug}/camouflages/${mix_id}/`  
            return axios.delete(endpoint)
        },
        onSuccess: () => {
            displayNotify({status:"success", title:"Успех!", description: "Камуфляж успешно удалён"})
            queryClient.invalidateQueries({ queryKey: qKeys });
        },
        onError: (error:AxiosError) => displayNotify({status:"error", title:"Ошибка!", description: "Камуфляж не удалён"}) 
    })
}